export const reducerPath = 'accessToken';
export const guestReducerPath = 'guestAccessTokenApi';
